<template>
    <div class="individual-search-inner-container" @click="hideFilters">

        <ais-instant-search
            :search-client="searchClient"
            :index-name="algoliaPrefix + 'JOBS'"
            :initial-ui-state="initialUiState"
            :insights-client="aa">

            <ais-configure filters="active:true" />
<!--            v-bind="searchParameters"-->
<!--                           :around-lat-lng-via-iP.camel="true"-->


            <div class="search-header">

                <h1 class="search-heading-2">Job Results</h1>

                <ais-search-box />

                <div class="current-filters">
                    <ais-current-refinements />
                </div>

                <div class="pagination-value">
                    <ais-stats>
                      <template #default="{ hitsPerPage, nbPages, nbHits, page, processingTimeMS, query }"><p>
                          Showing {{ (page * 8) + 1 }}-{{ (page * 8) + 8 }} of {{ nbHits }} results
                      </p></template>
                    </ais-stats>
                </div>

            </div>

            <div class="mobile-filters-button btn btn-primary btn-gold" @click.stop="showFilters">Filters</div>

            <div class="search-content">

                <transition name="fade" mode="out-in">
                    <div class="left-panel-close-backing" v-if="showingFilters" @click.stop="hideFilters"></div>
                </transition>

                <div class="left-panel" :class="{ 'open': showingFilters }" @click.prevent.stop>
                    <div class="mobile-filters-close" @click="hideFilters">Close Filters</div>

                    <h3>Filter results by</h3>

                    <h4>City</h4>
                    <ais-refinement-list attribute="location.name" :limit="5" show-more>
                        <template #default="{ items, isShowingMore, isFromSearch, canToggleShowMore, refine, createURL, toggleShowMore, searchForItems }"><div>

                            <ul>
                                <li v-if="isFromSearch && !items.length">No results.</li>
                                <li v-for="item in items" :key="item.value" :class="{ 'is-checked': item.isRefined }">
                                    <a :href="createURL(item)" @click.prevent="refine(item.value)">
                                        <span class="check"></span>
                                        <span class="refinement-label">
                                            <ais-highlight attribute="item" :hit="item"/>
<!--                                            <span class="count">{{ item.count.toLocaleString() }}</span>-->
                                        </span>
                                    </a>
                                </li>
                            </ul>

                            <button @click="toggleShowMore" :disabled="!canToggleShowMore" v-if="canToggleShowMore">
                                {{ !isShowingMore ? 'Show more' : 'Show less'}}
                            </button>

                        </div></template>
                    </ais-refinement-list>

                    <h4>Job Type</h4>
                    <ais-refinement-list attribute="family.name" :limit="5" show-more>
                        <template #default="{ items, isShowingMore, isFromSearch, canToggleShowMore, refine, createURL, toggleShowMore, searchForItems }"><div>

                            <ul>
                                <li v-if="isFromSearch && !items.length">No results.</li>
                                <li v-for="item in items" :key="item.value" :class="{ 'is-checked': item.isRefined }">
                                    <a :href="createURL(item)" @click.prevent="refine(item.value)">
                                        <span class="check"></span>
                                        <span class="refinement-label">
                                            <ais-highlight attribute="item" :hit="item"/>
<!--                                            <span class="count">{{ item.count.toLocaleString() }}</span>-->
                                        </span>
                                    </a>
                                </li>
                            </ul>

                            <button @click="toggleShowMore" :disabled="!canToggleShowMore" v-if="canToggleShowMore">
                                {{ !isShowingMore ? 'Show more' : 'Show less'}}
                            </button>

                        </div></template>
                    </ais-refinement-list>

                    <div :class="{'sr-only' : show_family_filter !== 'true' }">
                        <h4>Job Group</h4>
                        <ais-refinement-list attribute="family_group" :limit="5" show-more>
                            <template #default="{ items, isShowingMore, isFromSearch, canToggleShowMore, refine, createURL, toggleShowMore, searchForItems }"><div>

                                <ul>
                                    <li v-if="isFromSearch && !items.length">No results.</li>
                                    <li v-for="item in items" :key="item.value" :class="{ 'is-checked': item.isRefined }">
                                        <a :href="createURL(item)" @click.prevent="refine(item.value)">
                                            <span class="check"></span>
                                            <span class="refinement-label">
                                                <ais-highlight attribute="item" :hit="item"/>
                                                <!--                                            <span class="count">{{ item.count.toLocaleString() }}</span>-->
                                            </span>
                                        </a>
                                    </li>
                                </ul>

                                <button @click="toggleShowMore" :disabled="!canToggleShowMore" v-if="canToggleShowMore">
                                    {{ !isShowingMore ? 'Show more' : 'Show less'}}
                                </button>

                            </div></template>
                        </ais-refinement-list>
                    </div>

                    <h4>Type</h4>
                    <ais-refinement-list attribute="type" :limit="5" show-more>
                        <template #default="{ items, isShowingMore, isFromSearch, canToggleShowMore, refine, createURL, toggleShowMore, searchForItems }"><div>

                            <ul>
                                <li v-if="isFromSearch && !items.length">No results.</li>
                                <li v-for="item in items" :key="item.value" :class="{ 'is-checked': item.isRefined }">
                                    <a :href="createURL(item)" @click.prevent="refine(item.value)">
                                        <span class="check"></span>
                                        <span class="refinement-label">
<!--                                            item.-->
                                            <span class="ais-Highlight" v-text="formatType(item.label)"></span>
<!--                                            <ais-highlight attribute="item" :hit="item"/>-->
<!--                                            <span class="count">{{ item.count.toLocaleString() }}</span>-->
                                        </span>
                                    </a>
                                </li>
                            </ul>

<!--                            <button @click="toggleShowMore" :disabled="!canToggleShowMore">-->
<!--                                {{ !isShowingMore ? 'Show more' : 'Show less'}}-->
<!--                            </button>-->

                        </div></template>
                    </ais-refinement-list>

                    <ais-clear-refinements>
                        <template #default="{ canRefine, refine, createURL }"><div>
                            <a
                                :href="createURL()"
                                @click.prevent="refine"
                                v-if="canRefine"
                                class="clear-filters-button"
                            >
                                Clear Filters
                            </a>
                        </div></template>
                    </ais-clear-refinements>

                    <ais-configure :hitsPerPage="8" />
                </div>
                <div class="right-panel">
                    <ais-hits>

                        <template #item="{ item }"><a :href="item.url" target="_blank" class="individual-search-result-item">
                            <div class="item-thumbnail" v-if="item.photo">
                                <img :src="item.photo" :alt="item.name">
                            </div>

                            <div class="item-inner-contents">
                                <div class="item-details">
                                    <h3>{{ item.name }}</h3>
                                    <div class="item-location">
                                        <span v-text="item.location[0].name" v-if="item.location.length"></span>
                                        <span class="divider" v-if="item.location.length">|</span>
                                        <span v-text="item.job_code"></span>
<!--                                        <span class="divider">|</span>-->
<!--                                        <span v-text="formatDateDisplayCreated(item.created)"></span>-->
                                    </div>
                                </div>

<!--                                <div class="item-controls">-->
<!--                                    <a :href="'tel:' + item.phone" class="item-phone"><span v-text="formatPhoneNumber(item.phone)"></span></a>-->
<!--                                    <a v-if="item.yext_url" :href="item.yext_url" class="btn btn-primary btn-gold">Profile</a>-->
<!--                                </div>-->
                            </div>

                        </a></template>

                    </ais-hits>
                </div>

            </div>

            <div class="search-results-pagination">
                <ais-pagination>
                    <template #default="{ currentRefinement, nbPages, pages, isFirstPage, isLastPage, refine, createURL }"><div class="ais-pagination-inner">
                        <button :disabled="isFirstPage" class="btn btn-back btn-back-gold" :href="createURL(currentRefinement - 1)" @click.prevent="refine(currentRefinement - 1)">Previous</button>
                        <button :disabled="isLastPage" class="btn btn-more" :href="createURL(currentRefinement + 1)" @click.prevent="refine(currentRefinement + 1)">Next</button>
                    </div></template>
                </ais-pagination>
            </div>

        </ais-instant-search>

    </div>
</template>

<script>
    import algoliasearch from 'algoliasearch';

    const algoliaPrefix = (window.ajax_global && window.ajax_global.algolia_prefix) ? window.ajax_global.algolia_prefix : 'prod_';
    const searchClient = algoliasearch('O4J2BVWP7X', '25e82b9ff49bfc98eeaea844742d9654');
    const index = searchClient.initIndex(algoliaPrefix + 'JOBS');

    export default {

    props: ['query_in', 'show_family_filter'],

    data() {
        return {
            query: '',
            originalQuery: '',
            algoliaPrefix,
            searchClient,
            index,
            initialUiState: {
                [algoliaPrefix + 'JOBS']: {
                    query: this.query_in,
                    refinementList: {
                        active: true,
                        "family_group": window.filterFamiliesNew,
                        "family.name": window.filterCategoriesNew,
                    },
                },
            },
            monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            showingFilters: false
        }
    },

    mounted() {

        this.query = this.query_in;
        this.originalQuery = this.query_in;

        setInterval(function () {
            $('.ais-CurrentRefinements-item').each(function () {
                if ($(this).find('.ais-CurrentRefinements-label').text() === "Family_group: ") {
                    $(this).find('.ais-CurrentRefinements-label').text('Job Group: ');
                    if (!window.showFamilyFilter) $(this).addClass('sr-only');
                }

                if($(this).find('.ais-CurrentRefinements-label').text() === "Location.name: ") {
                    $(this).find('.ais-CurrentRefinements-label').text('City: ');
                }

                if($(this).find('.ais-CurrentRefinements-label').text() === "Family.name: ") {
                    $(this).find('.ais-CurrentRefinements-label').text('Job Type: ');
                }

                if($(this).find('.ais-CurrentRefinements-categoryLabel').text() === "Full_time ") {
                    $(this).find('.ais-CurrentRefinements-categoryLabel').text('Full Time');
                }

                if($(this).find('.ais-CurrentRefinements-categoryLabel').text() === "Part_time ") {
                    $(this).find('.ais-CurrentRefinements-categoryLabel').text('Part Time');
                }
            });
        }, 300);

    },

    components: {},

    watch:{},

    computed: {
        searchParameters: function () {
            if(typeof window.filterFamilies !== 'undefined') {
                return {
                    facetFilters: [
                        window.filterFamilies
                    ]
                };
            } else if(typeof window.filterCategories !== 'undefined') {
                return {
                    facetFilters: [
                        window.filterCategories
                    ]
                };
            } else {
                return {};
            }
        },
    },

    methods: {

        formatPhoneNumber: function (phoneNumberString) {
            var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
            if (match) {
                return '(' + match[1] + ') ' + match[2] + '-' + match[3]
            }
            return null
        },

        formatArrayDisplay: function (array, maxLength = 0) {

            let returnString = '';

            if(maxLength > 0 && array.length > maxLength) {
                for (let i = 0; i < maxLength - 1; i++) {
                    if(returnString === "") {
                        returnString += this.decodeHTMLEntities(array[i]);
                    } else {
                        returnString += ', ' + this.decodeHTMLEntities(array[i]);
                    }
                }
                returnString += ' + more';
            } else {
                for (let i = 0; i < array.length; i++) {
                    if(returnString === "") {
                        returnString += this.decodeHTMLEntities(array[i]);
                    } else {
                        returnString += ', ' + this.decodeHTMLEntities(array[i]);
                    }
                }
            }

            return returnString;

        },

        decodeHTMLEntities: function (text) {
            var entities = [
                ['amp', '&'],
                ['apos', '\''],
                ['#x27', '\''],
                ['#x2F', '/'],
                ['#39', '\''],
                ['#47', '/'],
                ['lt', '<'],
                ['gt', '>'],
                ['nbsp', ' '],
                ['quot', '"']
            ];

            for (var i = 0, max = entities.length; i < max; ++i)
                text = text.replace(new RegExp('&'+entities[i][0]+';', 'g'), entities[i][1]);

            return text;
        },

        formatDateDisplayCreated: function (dateInput) {

            let dateTime = new Date(dateInput);

            if(this.isToday(dateTime)) {
                return 'Posted Today';
            } else if(this.isYesterday(dateTime)) {
                return 'Posted Yesterday';
            } else {
                return 'Posted ' + this.monthNames[dateTime.getMonth()] + ' ' + dateTime.getDay() + ', ' + dateTime.getFullYear();
            }

        },

        isToday: function (someDate) {
            const today = new Date()
            return someDate.getDate() === today.getDate() &&
                someDate.getMonth() === today.getMonth() &&
                someDate.getFullYear() === today.getFullYear()
        },

        isYesterday: function (someDate) {
            const today = new Date();
            const yesterday = new Date(today);

            yesterday.setDate(yesterday.getDate() - 1);

            return someDate.getDate() === yesterday.getDate() &&
                someDate.getMonth() === yesterday.getMonth() &&
                someDate.getFullYear() === yesterday.getFullYear()
        },

        formatType: function (value) {

            if(value === 'Full_time') {
                return 'Full Time';
            } else if (value === 'Part_time') {
                return 'Part Time';
            } else {
                return value;
            }

        },

        showFilters: function () {

            this.showingFilters = true;

        },

        hideFilters: function () {

            this.showingFilters = false;

        },

    }

}
</script>
